import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { trackCoachingCta } from "../../lib/analytics";

// Mobile-only bottom CTA, hidden over the hero and the request form.
const CoachingStickyCta = ({ t }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const form = document.getElementById("request");
      const formTop = form ? form.getBoundingClientRect().top : Infinity;
      setVisible(window.scrollY > 520 && formTop > window.innerHeight * 0.6);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] bg-[#05070B]/90 backdrop-blur-md border-t border-[#1E90FF]/20 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!visible}
    >
      <a
        href="#request"
        onClick={() => trackCoachingCta("mobile_sticky")}
        tabIndex={visible ? 0 : -1}
        data-testid="coaching-sticky-cta"
        className="h-12 w-full inline-flex items-center justify-center rounded-full bg-[#1E90FF] text-white font-semibold"
      >
        {t.ui.stickyCta} <ArrowRight size={18} className="ml-2" />
      </a>
    </div>
  );
};

export default CoachingStickyCta;
